import React from 'react';
import FilterPill from '../FilterPill/FilterPill';

type Props = {
    placeholdersCount: number;
};

export default function FilterBarLoading({placeholdersCount}: Props) {
    return (
        <>
            {Array(placeholdersCount)
                .fill('')
                .map((_, index) => (
                    <FilterPill label={''} key={index} loading />
                ))}
        </>
    );
}
